import {PageContent} from '@/components/organisms'
import {getPublicImageUrl} from '@/utils/commons'
import './_mediaGallery.scss'

const MediaGallery = ({productData, title}) => {
  const hasImage = !!(productData?.mediaUrl && productData?.mediaUrl.trim() !== '')

  return (
    <>
      <PageContent className="media-gallery-component bg-neutral-800 text-white" pageContentWrapperClassName="relative">
        <div className="flex flex-col gap-12">
          <div className="media-card">
            <div className="flex flex-col gap-8">
              <div
                className="file-media border-1 flex items-center justify-center overflow-hidden rounded-md border-dotted border-neutral-500"
                style={{width: 320, height: 240, background: '#18181b'}}
              >
                {hasImage ? (
                  <img
                    src={productData.mediaUrl}
                    alt={productData?.title || 'Media'}
                    className="max-h-full max-w-full object-contain"
                  />
                ) : (
                  <img
                    src={getPublicImageUrl('img/no-product-image-found.png')}
                    alt="no image"
                    className="h-full w-full object-cover"
                  />
                )}
              </div>
              <div className="mt-2 w-full">
                <div className="media-title-row flex items-center border-b border-neutral-600">
                  <span className="media-title-label">Title</span>
                  <span className="media-title-filename">{productData?.mediaUrl ? title : 'No filename'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageContent>
    </>
  )
}

export default MediaGallery
